import { render, staticRenderFns } from "./MediaGrid.vue?vue&type=template&id=2fc1e80a&scoped=true&"
import script from "./MediaGrid.vue?vue&type=script&lang=js&"
export * from "./MediaGrid.vue?vue&type=script&lang=js&"
import style0 from "./MediaGrid.vue?vue&type=style&index=0&id=2fc1e80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1e80a",
  null
  
)

export default component.exports